// extracted by mini-css-extract-plugin
module.exports = {"Loading":"EnableTfaForm_Loading__NwUed"};